module.exports = __webpack_public_path__ + "img/flag_in.29cf255d.svg";